import Box from "@mui/material/Box";
import { FS } from "@plannel/utils/font-util";

/*
 * 품목/거래처 검색 드롭다운의 그룹 한 덩어리(머리글 + 그 그룹의 항목들).
 *
 * 예전 머리글은 폭 전체를 채운 하늘색(#4fc3f7) 띠에 흰 글자였다. 팝업 안에서 제일 진한 면이
 * 머리글이라 정작 읽어야 할 항목보다 머리글이 먼저 눈에 들어왔고, 같은 화면의 Advanced Filter
 * 필드 드롭다운(옅은 회색 바탕 + primary 글자)과 나란히 놓으면 두 벌로 보였다.
 * 여기서 그 규격(AdvancedFilter.js 의 ListSubheader)에 맞춘다 — 값을 바꾸려면 두 곳을 함께.
 *
 * 첫 그룹의 윗선은 지운다: 팝업 위쪽 테두리와 1px 간격을 두고 겹쳐 두 줄로 보인다.
 */
const AutocompleteGroupHeader = ({ label, children }) => (
  <Box
    component="li"
    sx={{
      listStyle: "none",
      "&:first-of-type .autocomplete-group-head": { borderTop: 0, mt: 0 },
    }}
  >
    <Box
      className="autocomplete-group-head"
      sx={{
        mt: "4px",
        p: "5px 10px",
        borderRadius: "6px",
        borderTop: "1px solid",
        borderColor: "divider",
        bgcolor: "action.hover",
        color: "primary.main",
        fontSize: FS.SUB,
        fontWeight: 700,
        lineHeight: 1.5,
      }}
    >
      {label}
    </Box>
    {/* 항목은 머리글보다 한 칸 들여쓴다 — 어느 그룹에 속한 줄인지 색 대비 없이도 읽힌다 */}
    <Box className="Highlight-autocomplete">{children}</Box>
  </Box>
);

export default AutocompleteGroupHeader;
